import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { doc, updateDoc } from 'firebase/firestore';
import db from '../../firebase/firebase';
import { httpsCallable } from "firebase/functions";


const EditRestaurantForm = ({ restaurant, onClose, onUpdate }) => {
    const [formData, setFormData] = useState(restaurant);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const formRef = useRef(null);

    
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (formRef.current && !formRef.current.contains(event.target)) {
                onClose(); // Close the form
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData({ ...formData, [name]: value });
    // };
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === 'checkbox' ? checked : value;
        setFormData((prevData) => ({
            ...prevData,
            [name]: newValue,
        }));
    };

    const handleAuthorizationCodeChange = (e) => {
        const { name, value } = e.target;

        // Remove any non-alphanumeric characters except dashes
        let formattedValue = value.replace(/[^A-Za-z0-9]/g, '');

        // Insert the dash after 4 characters
        if (formattedValue.length > 4) {
            formattedValue = formattedValue.slice(0, 4) + '-' + formattedValue.slice(4, 8);
        }

        // Set the formatted value back into formData
        setFormData({
            ...formData,
            [name]: formattedValue.toUpperCase(), // Ensure it's uppercase
        });
    }

    const handleUppercaseAlphanumericChange = (e) => {
        const { name, value } = e.target;

        // Remove any non-alphanumeric characters
        let formattedValue = value.replace(/[^A-Za-z0-9]/g, '');

        // Set the formatted value back into formData as uppercase
        setFormData({
            ...formData,
            [name]: formattedValue.toUpperCase(), // Ensure it's always uppercase
        });
    };

    const handleAlphanumericChange = (e) => {
        const { name, value } = e.target;

        // Remove any non-numeric characters
        let formattedValue = value.replace(/[^0-9]/g, '');

        // Set the formatted value back into formData
        setFormData({
            ...formData,
            [name]: formattedValue, // Only numbers
        });
    };

    const handlePhoneNumberChange = (e) => {
        const { name, value } = e.target;
    
        // Remove all non-digit characters
        let formattedValue = value.replace(/\D/g, '');
    
        // Ensure it only has up to 10 digits
        if (formattedValue.length > 10) {
            formattedValue = formattedValue.slice(0, 10);
        }
    
        // Check if the number has exactly 10 digits
        if (formattedValue.length !== 10) {
            setError('Please enter a valid 10-digit phone number');
        } else {
            setError(''); // Clear the error if valid
        }
    
        // Set the formatted value back into formData
        setFormData({
            ...formData,
            [name]: formattedValue,
        });
    };
    

    const formatTPSNumber = (value) => {
        // Remove all non-numeric characters except 'R' and 'T'
        let cleanedValue = value.replace(/[^0-9]/gi, '');
    
        // Add 'RT' after 9 digits if it's not already there
        if (cleanedValue.length > 9 && !cleanedValue.includes('RT')) {
            cleanedValue = cleanedValue.substring(0, 9) + 'RT' + cleanedValue.substring(9);
        }
    
        // Ensure the format is 9 digits + 'RT' + up to 4 trailing digits
        const formattedValue = cleanedValue
            .replace(/(\d{9})(RT)?(\d{0,4}).*/, '$1RT$3') // Format to the TPS structure
            .substring(0, 15); // Ensures max length (9 digits + 'RT' + 4 digits)
    
        return formattedValue;
    };
    
    const handleTPSChange = (event) => {
        const { name, value } = event.target;

        setFormData((prev) => ({
            ...prev,
            [name]: formatTPSNumber(value), // Format the TPS number here
        }));
    };

    const formatTVQNumber = (value) => {
        // Remove all non-numeric characters
        let cleanedValue = value.replace(/[^0-9]/gi, '');
    
        // Add 'TQ' after 10 digits if it's not already there
        if (cleanedValue.length > 9 && !cleanedValue.includes('TQ')) {
            cleanedValue = cleanedValue.substring(0, 10) + 'TQ' + cleanedValue.substring(10);
        }
    
        // Ensure the format is 10 digits + 'TQ' + up to 4 trailing digits
        const formattedValue = cleanedValue
            .replace(/(\d{10})(TQ)?(\d{0,4}).*/, '$1TQ$3') // Format to the TPS structure
            .substring(0, 16); // Ensures max length (10 digits + 'TQ' + 4 digits)
    
        return formattedValue;
    };
    
    const handleTVQChange = (event) => {
        const { name, value } = event.target;

        setFormData((prev) => ({
            ...prev,
            [name]: formatTVQNumber(value), // Format the TPS number here
        }));
    };

    const handlePostalCode = (e) => {
        const { name, value } = e.target;
      
        if (name === "postalCode") {
          // Remove all non-alphanumeric characters
          let formattedValue = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      
          // Enforce the pattern A1A1A1
          if (formattedValue.length > 6) {
            formattedValue = formattedValue.slice(0, 6);
          }
      
          // Update the state with the formatted value
          setFormData((prevState) => ({
            ...prevState,
            [name]: formattedValue,
          }));
        } else {
          // Default handler for other inputs
          setFormData((prevState) => ({
            ...prevState,
            [name]: value,
          }));
        }
      };

    // const sendMerchantNotificationEditMerchantDev = async (merchantId, status) => {
    //     if (!merchantId) {
    //         throw new Error("merchantId is required");
    //     }

    //     if (!status) {
    //         throw new Error("status is required");
    //     }

    //     const headers = {
    //         "Authorization": `Bearer ${apiToken}`,
    //         "Accept": "application/json",
    //         "Content-Type": "application/json",
    //     };
    
    //     const body = JSON.stringify({
    //         "event" : "merchant_update_notification",
    //         "data" : "Merchant Data Updated"
    //     });
    
    //     try {
    //         const sendMerchantNotificationEditMerchantDev = httpsCallable(
    //             db.functions,
    //             "sendMerchantNotificationEditMerchantDev"
    //         );

    //         const result = await sendMerchantNotificationEditMerchantDev({
    //             merchantId,
    //             status
    //         });

    //         console.log("Notification sent:", result.data);
    //         return result.data;

    //     } catch (error) {
    //         console.error("Error sending notification:", error.message);
    //         throw error;
    //     }
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
    
        try {
            const restaurantRef = doc(db, "MEVMandatarys", restaurant.id);

            await updateDoc(restaurantRef, formData);
            onUpdate({ ...formData, id: restaurant.id });
            onClose();
            const merchantId = restaurant.cloverMerchantId;
            // await sendMerchantNotificationEditMerchantDev(merchantId);
            
        } catch (err) {
            console.error("Error details:", err);
            setError(`Failed to update restaurant and notify merchant. ${err.message}`);
        } finally {
            setLoading(false);
        }
    };

    const { t } = useTranslation();

    return (
        <div ref={formRef} className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded max-w-4xl h-[95vh] overflow-y-auto">
                <h2 className="text-xl text-sky-900 mb-4"><b>{t('edit_restaurant')} {restaurant.businessName}</b></h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4 flex justify-between w-full">
                        <div className="w-[33%]">
                            <label htmlFor="activitySubSector" className="block text-gray-700">{t('activity_sub_sector')}</label>
                            <select
                                id="activitySubSector"
                                name="activitySubSector"
                                value={formData.activitySubSector}
                                onChange={handleChange}
                                required
                                className="mt-1 p-2 w-full border rounded-lg"
                            >
                                <option value="" disabled>{t('option_select')}</option>
                                <option value="RES">Restaurant</option>
                                <option value="CDR">{t('food_truck')}</option>
                            </select>
                        </div>
                        <div className="w-[33%]">
                            <label htmlFor="authorizationCode" className="block text-gray-700">
                                {t('authorization_code')}
                            </label>
                            <input
                                type="text"
                                id="authorizationCode"
                                name="authorizationCode"
                                value={formData.authorizationCode}
                                onChange={handleAuthorizationCodeChange}
                                required
                                className="mt-1 p-2 w-full border rounded-lg"
                                maxLength={9} // 9 characters including the dash
                                placeholder="C8T8-W8W8"
                                pattern="[A-Za-z0-9]{4}-[A-Za-z0-9]{4}" // Optional: enforce the pattern in the UI
                            />
                        </div>
                        <div className="w-[33%]">
                            <label htmlFor="billingFileNo" className="block text-gray-700">{t('billing_file_number')}</label>
                            <input
                                type="text"
                                id="billingFileNo"
                                name="billingFileNo"
                                value={formData.billingFileNo}
                                onChange={handleUppercaseAlphanumericChange}
                                required
                                className="mt-1 p-2 w-full border rounded-lg"
                            />
                        </div>
                    </div>
                    <div className="mb-4 flex justify-between w-full">
                        <div className="w-[48%]">
                            <label htmlFor="businessName" className="block text-gray-700">{t('business_name')}</label>
                            <input
                                type="text"
                                id="businessName"
                                name="businessName"
                                value={formData.businessName}
                                onChange={handleChange}
                                required
                                className="mt-1 p-2 w-full border rounded-lg"
                            />
                        </div>
                        <div className="w-[48%]">
                            <label htmlFor="cloverMerchantId" className="block text-gray-700">{t('clover_merchant_id')}</label>
                            <input
                                type="text"
                                id="cloverMerchantId"
                                name="cloverMerchantId"
                                value={formData.cloverMerchantId}
                                onChange={handleUppercaseAlphanumericChange}
                                required
                                className="mt-1 p-2 w-full border rounded-lg"
                            />
                        </div>
                    </div>
                    <div className="mb-4 flex justify-between w-full">
                        <div className="w-[48%]">
                            <label htmlFor="identificationNo" className="block text-gray-700">{t('identification_number')}</label>
                            <input
                                type="text"
                                id="identificationNo"
                                name="identificationNo"
                                value={formData.identificationNo}
                                onChange={handleAlphanumericChange}
                                required
                                placeholder='1234567890'
                                className="mt-1 p-2 w-full border rounded-lg"
                            />
                        </div>
                        <div className="w-[48%]">
                            <label htmlFor="phone" className="block text-gray-700">
                                {t('phone_number')}
                            </label>
                            <input
                                type="text"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handlePhoneNumberChange}
                                required
                                className="mt-1 p-2 w-full border rounded-lg"
                                placeholder="1234567890"
                                maxLength={17}
                            />
                        </div>
                    </div>
                    <div className="mb-4 flex justify-between w-full">
                        <div className="w-[33%]">
                            <label htmlFor="street1" className="block text-gray-700">{t('street_no')}</label>
                            <input
                                type="text"
                                id="street1"
                                name="street1"
                                value={formData.street1}
                                onChange={handleChange}
                                required
                                className="mt-1 p-2 w-full border rounded-lg"
                            />
                        </div>
                        <div className="w-[33%]">
                            <label htmlFor="street2" className="block text-gray-700">{t('street_name')}</label>
                            <input
                                type="text"
                                id="street2"
                                name="street2"
                                value={formData.street2}
                                onChange={handleChange}
                                required
                                className="mt-1 p-2 w-full border rounded-lg"
                            />
                        </div>
                        <div className="w-[33%]">
                            <label htmlFor="city" className="block text-gray-700">{t('city')}</label>
                            <input
                                type="text"
                                id="city"
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                                required
                                className="mt-1 p-2 w-full border rounded-lg"
                            />
                        </div>
                    </div>
                    <div className="mb-4 flex justify-between w-full">
                        <div className="w-[48%]">
                            <label htmlFor="province" className="block text-gray-700">{t('province')}</label>
                            <input
                                type="text"
                                id="province"
                                name="province"
                                value={formData.province}
                                onChange={handleChange}
                                required
                                className="mt-1 p-2 w-full border rounded-lg"
                            />
                        </div>
                        <div className="w-[48%]">
                            <label htmlFor="postalCode" className="block text-gray-700">{t('postal_code')}</label>
                            <input
                                type="text"
                                id="postalCode"
                                name="postalCode"
                                value={formData.postalCode}
                                onChange={handlePostalCode}
                                required
                                className="mt-1 p-2 w-full border rounded-lg"
                            />
                        </div>
                    </div>
                    <div className="mb-4 flex justify-between w-full">
                        <div className="w-[48%]">
                            <label htmlFor="tpsNo" className="block text-gray-700">{t('tps_number')}</label>
                            <input
                                type="text"
                                id="tpsNo"
                                name="tpsNo"
                                value={formData.tpsNo}
                                onChange={handleTPSChange}
                                placeholder='000000000RT0000'
                                required
                                className="mt-1 p-2 w-full border rounded-lg"
                            />
                        </div>
                        <div className="w-[48%]">
                            <label htmlFor="tvqNo" className="block text-gray-700">{t('tvq_number')}</label>
                            <input
                                type="text"
                                id="tvqNo"
                                name="tvqNo"
                                value={formData.tvqNo}
                                onChange={handleTVQChange}
                                placeholder='0000000000TQ0000'
                                required
                                className="mt-1 p-2 w-full border rounded-lg"
                            />
                        </div>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="subNumber" className="block text-gray-700">{t('subNumber')}</label>
                        <input
                            type="text"
                            id="stasubNumbertus"
                            name="subNumber"
                            value={formData.subNumber}
                            onChange={handleChange}
                            className="mt-1 p-2 border rounded-lg"
                        />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="status" className="block text-gray-700">{t('status')}</label>
                        <input
                            type="checkbox"
                            id="status"
                            name="status"
                            checked={true}
                            onChange={handleChange}
                            className="mt-1 p-2 border rounded-lg"
                        />
                    </div>
                    {error && <p className="text-red-500 mt-1">{error}</p>}
                    <div className="flex justify-end">
                        <button
                            type="button"
                            className="mr-4 px-4 py-2 bg-gray-300 rounded"
                            onClick={onClose}
                            disabled={loading}
                        >
                            {t('cancel')}
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-sky-900 text-white rounded"
                            disabled={loading}
                        >
                            {loading ? t('saving') : t('save')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditRestaurantForm;
